import React from "react";
import LegalLayout, { H2, P, UL } from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Notice" subtitle="Legal · 04" lastUpdated="February 2026">
      <P>
        This notice explains how CAMO uses cookies and similar technologies on the website. By using the
        Site, you consent to the use of cookies as described below, in accordance with Italian Legislative
        Decree 196/2003, the ePrivacy Directive, and Article 7 GDPR.
      </P>

      <H2>1. What is a Cookie?</H2>
      <P>
        A cookie is a small text file stored on your device when you visit a website. Cookies allow the
        Site to recognise your browser and remember information across requests.
      </P>

      <H2>2. Cookies We Use</H2>
      <UL>
        <li>
          <strong>Strictly Necessary</strong> — session_token (httpOnly), authentication for the admin
          console. These cookies cannot be refused as they are required to operate the service.
        </li>
        <li>
          <strong>Functional</strong> — cookie consent flag (localStorage). Stores your preference so we
          do not show the banner repeatedly.
        </li>
        <li>
          <strong>Third-party</strong> — PayPal may set its own cookies when you click a PayPal link. See
          PayPal's cookie notice. Resend (transactional email) does not set cookies on this Site.
        </li>
      </UL>
      <P>
        CAMO does <strong>not</strong> use advertising, profiling, or third-party analytics cookies.
      </P>

      <H2>3. Managing Cookies</H2>
      <P>
        Most browsers allow you to refuse, delete, or block cookies. Doing so may impair certain
        functionality (notably the admin console). Refer to your browser documentation for instructions.
      </P>
      <P>
        You can also reset your consent on this Site by clearing your browser storage for camointelligence.
      </P>

      <H2>4. Updates</H2>
      <P>
        We may update this notice from time to time. Material changes will be announced on the Site.
      </P>
    </LegalLayout>
  );
}
